import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { fetchWallet } from '../api/account';
import { formatPrice } from '../api/catalog';

/**
 * Single source of truth for the signed-in user's wallet balance, so the
 * navbar, account sub-nav, billing and checkout all show the same value.
 * Refresh it whenever the balance can change (top-up, order placement).
 */
export const useWalletStore = defineStore('wallet', () => {
  const availableCents = ref<number | null>(null);
  const loaded = ref(false);

  const formatted = computed(() => (availableCents.value == null ? '—' : formatPrice(availableCents.value)));

  async function refresh() {
    try {
      const w = await fetchWallet();
      availableCents.value = w.availableCents;
      loaded.value = true;
    } catch {
      /* guest / unreachable — leave as-is */
    }
  }

  async function ensureLoaded() {
    if (loaded.value) return;
    await refresh();
  }

  function reset() {
    availableCents.value = null;
    loaded.value = false;
  }

  return { availableCents, loaded, formatted, refresh, ensureLoaded, reset };
});
